import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
	selector: 'portals-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
	@Input('showIf') showIf: boolean = false;
	diameter: number = 20;

	constructor(private renderer: Renderer2, private el: ElementRef, private changeDetector: ChangeDetectorRef) {}

	ngAfterViewInit() {
		// spinner block
		let blocker: any = this.el.nativeElement.querySelector('.blocker');

		// user element
		let firstChild: any = Array.from(this.el.nativeElement.children).find((el) => el !== blocker);

		if (firstChild) {
			//if text, this is null
			let firstChildStyle = window.getComputedStyle(firstChild);
			// if user element is a block, change this element to block
			if (firstChildStyle.display === 'block') {
				this.el.nativeElement.style.display = 'block';
			}
			// if user element has borderRadius, make blocker the same
			if (firstChildStyle.borderRadius) {
				if (blocker) {
					blocker.style.borderRadius = firstChildStyle.borderRadius;
				}
			}
			// if the user element is big, change the spinner size bigger
			if (parseInt(firstChild.style.height) >= 200) {
				this.diameter = 40;
				this.changeDetector.detectChanges();
			}
		}
	}
}
